import WeatherIcon0 from "./0.png";
import WeatherIcon00 from "./00.png";
import WeatherIcon01 from "./01.png";
import WeatherIcon02 from "./02.png";
import WeatherIcon03 from "./03.png";
import WeatherIcon04 from "./04.png";
import WeatherIcon05 from "./05.png";
import WeatherIcon06 from "./06.png";
import WeatherIcon07 from "./07.png";
import WeatherIcon08 from "./08.png";
import WeatherIcon09 from "./09.png";
import WeatherIcon1 from "./1.png";
import WeatherIcon2 from "./2.png";
import WeatherIcon3 from "./3.png";
import WeatherIcon4 from "./4.png";
import WeatherIcon5 from "./5.png";
import WeatherIcon6 from "./6.png";
import WeatherIcon7 from "./7.png";
import WeatherIcon8 from "./8.png";
import WeatherIcon9 from "./9.png";
import WeatherIcon10 from "./10.png";
import WeatherIcon11 from "./11.png";
import WeatherIcon12 from "./12.png";
import WeatherIcon13 from "./13.png";
import WeatherIcon14 from "./14.png";
import WeatherIcon15 from "./15.png";
import WeatherIcon16 from "./16.png";
import WeatherIcon17 from "./17.png";
import WeatherIcon18 from "./18.png";
import WeatherIcon19 from "./19.png";
import WeatherIcon20 from "./20.png";
import WeatherIcon21 from "./21.png";
import WeatherIcon22 from "./22.png";
import WeatherIcon23 from "./23.png";
import WeatherIcon24 from "./24.png";
import WeatherIcon25 from "./25.png";
import WeatherIcon26 from "./26.png";
import WeatherIcon27 from "./27.png";
import WeatherIcon28 from "./28.png";
import WeatherIcon29 from "./29.png";
import WeatherIcon30 from "./30.png";
import WeatherIcon31 from "./31.png";
import WeatherIcon32 from "./32.png";
import WeatherIcon33 from "./33.png";
import WeatherIcon34 from "./34.png";
import WeatherIcon35 from "./35.png";
import WeatherIcon36 from "./36.png";
import WeatherIcon37 from "./37.png";
import WeatherIcon38 from "./38.png";
import WeatherIcon39 from "./39.png";
import WeatherIcon40 from "./40.png";
import WeatherIcon41 from "./41.png";
import WeatherIcon42 from "./42.png";
import WeatherIcon43 from "./43.png";
import WeatherIcon44 from "./44.png";
import WeatherIcon45 from "./45.png";
import WeatherIcon46 from "./46.png";
import WeatherIcon47 from "./47.png";
import DefaultWeatherIcon from "./na.png";

type IconCode =
  | "0"
  | "00"
  | "01"
  | "02"
  | "03"
  | "04"
  | "05"
  | "06"
  | "07"
  | "08"
  | "09"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "10"
  | "11"
  | "12"
  | "13"
  | "14"
  | "15"
  | "16"
  | "17"
  | "18"
  | "19"
  | "20"
  | "21"
  | "22"
  | "23"
  | "24"
  | "25"
  | "26"
  | "27"
  | "28"
  | "29"
  | "30"
  | "31"
  | "32"
  | "33"
  | "34"
  | "35"
  | "36"
  | "37"
  | "38"
  | "39"
  | "40"
  | "41"
  | "42"
  | "43"
  | "44"
  | "45"
  | "46"
  | "47"
  | "na";

const iconMapping: { [key in IconCode]: string } = {
  "0": WeatherIcon0,
  "00": WeatherIcon00,
  "01": WeatherIcon01,
  "02": WeatherIcon02,
  "03": WeatherIcon03,
  "04": WeatherIcon04,
  "05": WeatherIcon05,
  "06": WeatherIcon06,
  "07": WeatherIcon07,
  "08": WeatherIcon08,
  "09": WeatherIcon09,
  "1": WeatherIcon1,
  "2": WeatherIcon2,
  "3": WeatherIcon3,
  "4": WeatherIcon4,
  "5": WeatherIcon5,
  "6": WeatherIcon6,
  "7": WeatherIcon7,
  "8": WeatherIcon8,
  "9": WeatherIcon9,
  "10": WeatherIcon10,
  "11": WeatherIcon11,
  "12": WeatherIcon12,
  "13": WeatherIcon13,
  "14": WeatherIcon14,
  "15": WeatherIcon15,
  "16": WeatherIcon16,
  "17": WeatherIcon17,
  "18": WeatherIcon18,
  "19": WeatherIcon19,
  "20": WeatherIcon20,
  "21": WeatherIcon21,
  "22": WeatherIcon22,
  "23": WeatherIcon23,
  "24": WeatherIcon24,
  "25": WeatherIcon25,
  "26": WeatherIcon26,
  "27": WeatherIcon27,
  "28": WeatherIcon28,
  "29": WeatherIcon29,
  "30": WeatherIcon30,
  "31": WeatherIcon31,
  "32": WeatherIcon32,
  "33": WeatherIcon33,
  "34": WeatherIcon34,
  "35": WeatherIcon35,
  "36": WeatherIcon36,
  "37": WeatherIcon37,
  "38": WeatherIcon38,
  "39": WeatherIcon39,
  "40": WeatherIcon40,
  "41": WeatherIcon41,
  "42": WeatherIcon42,
  "43": WeatherIcon43,
  "44": WeatherIcon44,
  "45": WeatherIcon45,
  "46": WeatherIcon46,
  "47": WeatherIcon47,
  na: DefaultWeatherIcon,
};

const getWeatherIconPath = (iconCode: IconCode): string => {
  return iconMapping[iconCode] || iconMapping["na"]; // Return the icon or a default icon if not found
};

export default getWeatherIconPath;
